module.exports = __webpack_public_path__ + "static/img/Tim-Brasher.849958f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tim-Brasher.jpg
// module id = xoW0
// module chunks = 0